import * as React from 'react'

function SvgContactInfoIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.319 12.271L7.512 9l-3.448 1.908s-.655 3.067 2.238 6.714c2.893 3.646 7.576 3.373 7.576 3.373L16 17.724l-3.183-1.84-1.293 1.363s-1.12 0-2.42-1.159c-1.302-1.158-1.31-2.59-1.31-2.59l1.525-1.226zM12 4h9M12 8h9M15 12h6"
        stroke="currentColor"
        strokeWidth={1.6}
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default SvgContactInfoIcon
